export { default as about } from "./about"
export { default as leads } from "./leads"
export { default as partnerships } from "./partnerships"

export const members = "60,000"

export const orgName = "Ryse Network"

export const orgAcronym = "Ryse"
